import $ from 'jquery';
import $script from 'scriptjs';
import ModalContent from '../components/ModalContent';
import ModalView from '../components/ModalView';

function recoverPassword() {
  $('.recover-password').toggle();
  $('.customer-login').toggle();
}

function checkForReset() {
  if ($('.reset-check').data('successful-reset') === true) {
    $('.successful-reset').show();
  }
}

function deleteAddress(e) {
  const addressID = $(e.target).parents('[data-address-id]').data('address-id');
  Shopify.CustomerAddress.destroy(addressID);
}

function editAddress(e) {
  const addressID = $(e.target).parents('[data-address-id]').data('address-id');

  const modalContent = new ModalContent({
    title: false,
    message: false,
  });

  return new ModalView({
    model: modalContent,
    el: $(`.modal-wrapper[data-address-id='${addressID}']`),
  });
}

function cancelEditing(e) {
  const addressID = $(e.target).parents('[data-address-id]').data('address-id');
  $(`.customer-address[data-address-id='${addressID}']`).removeClass('editing');
  $(`.customer-address-edit-form[data-address-id='${addressID}']`).removeClass('show');
}

function toggleNewAddress() {
  $('.add-new-address').toggle();
  $('.customer-new-address').toggleClass('show');
}

export default class TemplateAccount {
  constructor({ el }) {
    this.$el = $(el);
    const $scripts = $('[data-scripts]');

    $script(
      [
        $scripts.data('shopify-common'),
        $scripts.data('shopify-api-url'),
        $scripts.data('customer-area'),
      ], () => {
        $script($scripts.data('shopify-countries'), () => {
          this._bindEvents();
          if ($(document.body).hasClass('template-customers-addresses')) { this.prepareAddresses(); }
          if ($(document.body).hasClass('template-customers-login')) { checkForReset(); }
          if (window.location.hash === '#recover') { recoverPassword(); }
        });
      });
  }

  _bindEvents() {
    this.events = [
      $('.delete-address', this.$el).on('click.account', event => deleteAddress(event)),
      $('.edit-address', this.$el).on('click.account', event => editAddress(event)),
      $('.cancel-edit', this.$el).on('click.account', event => cancelEditing(event)),
      $('.toggle-new-address', this.$el).on('click.account', event => toggleNewAddress(event)),
      $('.toggle-forgetfulness span', this.$el).on('click.account', event => recoverPassword(event)),
    ];
  }

  _unbindEvents() {
    this.events.forEach($el => $el.off('.account'));
  }

  prepareAddresses() {
    this.countryProvinceSelector = new Shopify.CountryProvinceSelector('address-country', 'address-province', {
      hideElement: 'address-province-container',
    });

    $('.customer-address').each((index, address) => {
      const addressID = $(address).data('address-id');
      this.countryProvinceSelector = new Shopify.CountryProvinceSelector(`address-country-${addressID}`, `address-province-${addressID}`, {
        hideElement: `address-province-container-${addressID}`,
      });
    });
  }

  onSectionUnload() {
    this._unbindEvents();
  }
}
